var map = {
	"./Kay-2.jpg": 130,
	"./NYX.svg": 131,
	"./Untitled.jpg": 132,
	"./azah-logo-jp.jpg": 133,
	"./aztec-secret-logo.png": 134,
	"./bioderma.png": 135,
	"./blue-nectar.jpg": 136,
	"./cvm-health-logo_300x300.webp": 137,
	"./derma-co-logo.png": 138,
	"./engage-logo.jpg": 139,
	"./everteen.jpg": 140,
	"./freewill-2.svg": 141,
	"./hapdco.png": 142,
	"./hip-hop-logo.png": 143,
	"./la-organo.png": 144,
	"./lakme.png": 145,
	"./loreal-1.png": 146,
	"./mama-earth-logo.png": 147,
	"./nature_sure.jpg": 148,
	"./neud-logo.png": 149,
	"./nivea.svg": 150,
	"./nykaa.svg": 151,
	"./palmers.jpg": 152,
	"./positive.png": 153,
	"./roop-mantra.png": 154,
	"./shankara-logo.png": 155,
	"./simple-skin-logo.webp": 156,
	"./st-ives.jpg": 157,
	"./the-moms-co.png": 158,
	"./top-gummy.png": 159,
	"./wet-n-dry.jpg": 160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;